import { numberTest, resultThrow } from "@ixfx/guards";
import { guard } from "./guard.js";
import { fromCartesian as PolarFromCartesian } from "../polar/index.js";
import { rotate as PolarRotate, toCartesian as PolarToCartesian } from "../polar/index.js";
export function rotate(pt, amountRadian, origin) {
    if (typeof origin === `undefined`)
        origin = { x: 0, y: 0 };
    guard(origin, `origin`);
    resultThrow(numberTest(amountRadian, ``, `amountRadian`));
    const arrayInput = Array.isArray(pt);
    // no-op
    if (amountRadian === 0)
        return pt;
    if (!arrayInput) {
        pt = [pt];
    }
    const ptAr = pt;
    for (const [index, p] of ptAr.entries())
        guard(p, `pt[${index}]`);
    const asPolar = ptAr.map((p) => PolarFromCartesian(p, origin));
    const rotated = asPolar.map((p) => PolarRotate(p, amountRadian));
    const asCartesisan = rotated.map((p) => PolarToCartesian(p, origin));
    return arrayInput ? asCartesisan : asCartesisan[0];
}
